const annoucementVisibility = () => {
  const announcementBar = document.querySelector('.announcement-bar');
  const htmlBody = document.body;
  if (htmlBody.classList.contains('template-collection') || htmlBody.classList.contains('template-product')) {
    announcementBar.classList.add('announcement-bar--is-visible');
  }
};

export default annoucementVisibility;
